import { meetingLinkApi } from '../api/meeting-link'

export const {
  useCreateMeetingLinkAvailabilityMutation,
  useCreateUnavailabilityMutation,
  useDeleteUnavailabilityMutation,
  usePreviewUnavailabilityMutation,
  useUpdateAvailabilityMutation,
  useGetMeetingLinkQuery,
  useGetMeetingLinksQuery,
  useLazyGetMeetingLinkQuery,
  useLazyGetMeetingLinksQuery,
  useUpdateMeetingLinkMutation,
  useDeleteMeetingLinkMutation,
  useEnterMeetingLinkMutation,
  useLeaveMeetingLinkMutation,
} = meetingLinkApi
